export const themeColorSemanticShadows = {
  "themeColor.nav.active": {
    value: {
      base: "{shadows.shadow}",
      _themeBlack: "{shadows.shadow-none}",
      _themeWhite: "{shadows.shadow-sm}",
    },
  },
  "themeColor.avatar.hover": {
    value: {
      base: "{shadows.sm}",
      _themeBlack: "{shadows.md}",
      _themeWhite: "{shadows.sm}",
    },
  },
  "themeColor.shadow.default": {
    value: {
      base: "{shadows.shadow}",
      _themeBlack: "{shadows.shadow-primary}",
      _themeWhite: "{shadows.shadow}",
    },
  },
  "themeColor.shadow.md": {
    value: {
      base: "{shadows.shadow-md}",
      _themeBlack: "{shadows.shadow-primary-md}",
      _themeWhite: "{shadows.shadow-md}",
    },
  },
  "themeColor.shadow.lg": {
    value: {
      base: "{shadows.shadow-lg}",
      _themeBlack: "{shadows.shadow-primary-lg}",
      _themeWhite: "{shadows.shadow-lg}",
    },
  },
  "themeColor.shadow.xl": {
    value: {
      base: "{shadows.shadow-xl}",
      _themeBlack: "{shadows.shadow-primary-xl}",
      _themeWhite: "{shadows.shadow-xl}",
    },
  },
  "themeColor.shadow.2xl": {
    value: {
      base: "{shadows.shadow-2xl}",
      _themeBlack: "{shadows.shadow-primary-2xl}",
      _themeWhite: "{shadows.shadow-2xl}",
    },
  },
  "themeColor.form.focus": {
    value: {
      base: "0 0 0 3px {colors.primary.200}",
      _themeBlack: "0 0 0 3px {colors.primary.900}",
      _themeWhite: "0 0 0 3px {colors.primary.100}",
    },
  },
  "themeColor.form.errorFocus": {
    value: {
      base: "0 0 0 3px {colors.red.200}",
      _themeBlack: "0 0 0 3px {colors.red.900}",
      _themeWhite: "0 0 0 3px {colors.red.100}",
    },
  },
};
